/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};




//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/modules/_perform.js
// module id = 433
// module chunks = 60